import React from "react";
import MyNFTs from "@/components/Pages/Dashboard/MyNFTs";

const MyNFTsPage: React.FC = () => {
  return <MyNFTs />;
};

export default MyNFTsPage;
